export default {
  name: 'permissions',
  checked: 'checked',
  manager: 'manager',
  csv: 'csv',
  insights: 'insights',
  leads: 'leads',
  admin: 'admin'
};
